import axios from "axios";
// import { API_BASE_URL, IDENTITY_ENDPOINT_URL } from 'configs/AppConfig';
import {ACCOUNT_INVOICE} from "constants/AuthConstant";
import { notification } from "antd";
import moment from "moment";
import {LOGIN_INVOICE} from "../constants/ApiConstant";

const service = axios.create({
  baseURL: process.env.REACT_APP_SINVOICE_URL,
  timeout: 60000,
});
const TOKEN_PAYLOAD_KEY = "authorization";
service.interceptors.request.use(
  async (config) => {
    const jwtToken = localStorage.getItem(ACCOUNT_INVOICE) || null;
    if (jwtToken) {
      const tokenData = JSON.parse(jwtToken);
      const {iat, expires_in, access_token, username, password} = tokenData;
      const now = moment().unix();
      const timeExpire = iat + expires_in;
      const timeDiff = moment(now).diff(moment(timeExpire), 'millisecond');
      if (!access_token || timeDiff >= 0) {
        const response = await axios.post(`${process.env.REACT_APP_SINVOICE_URL}${LOGIN_INVOICE}`, {username, password});
        if (response.data.access_token) {
          localStorage.setItem(ACCOUNT_INVOICE, JSON.stringify({
            ...tokenData,
            ...response.data,
          }));
          config.headers[
              TOKEN_PAYLOAD_KEY
              ] = `Bearer ${response.data.access_token}`;
        }
      } else {
        config.headers[TOKEN_PAYLOAD_KEY] = `Bearer ${access_token}`;
      }
    }
    return config;
  },
  (error) => {
    notification.error({
      message: "Error",
    });
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    return response.data;
  },
  async (error) => {
    let notificationParam = {
      message: "",
    };
    if (error.response) {
      notificationParam.message = error.response.data?.data;
    } else {
      notificationParam.message = "Lỗi kết nối mạng";
    }

    if (!notificationParam.message) {
      notificationParam.message = "Vui lòng kiểm tra lại thông tin kết nối";
    }
    notification.error(notificationParam);

    return Promise.reject(error);
  }
);

export default service;
